import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
const store = new Vuex.Store({
    state : {
        qualificationcategory1 : 3170011,
        qualificationcategory2 : 2868609,
        qualificationcategory3 : 2574349,
        qualificationcategory4 : 2299439,
        qualificationcategory5 : 2149436 
    }
})
export default store;